module.exports = __webpack_public_path__ + "img/calculator_poster.134737e2.png";